import React from "react";

// Animated SVG radar chart (5 axes)
// scores: { marketStructure, ta, risk, psychology, strategy } 0-100
export default function KnowledgeRadar({ scores, size = 260 }) {
  const axes = [
    { key: "marketStructure", label: "Market" },
    { key: "ta", label: "TA" },
    { key: "risk", label: "Risk" },
    { key: "psychology", label: "Psych" },
    { key: "strategy", label: "Strategy" },
  ];
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 34;

  const pointAt = (idx, value) => {
    const angle = (Math.PI * 2 * idx) / axes.length - Math.PI / 2;
    const rr = r * (value / 100);
    return [cx + Math.cos(angle) * rr, cy + Math.sin(angle) * rr];
  };

  const ringPoints = (frac) =>
    axes
      .map((_, i) => {
        const a = (Math.PI * 2 * i) / axes.length - Math.PI / 2;
        return `${cx + Math.cos(a) * r * frac},${cy + Math.sin(a) * r * frac}`;
      })
      .join(" ");

  const shape = axes
    .map((ax, i) => {
      const v = Math.max(0, Math.min(100, scores?.[ax.key] || 0));
      const p = pointAt(i, v);
      return `${p[0]},${p[1]}`;
    })
    .join(" ");

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="Knowledge Graph Radar">
      {/* Rings */}
      {[0.25, 0.5, 0.75, 1].map((f, i) => (
        <polygon key={i} className="flexx-radar-grid" points={ringPoints(f)} />
      ))}
      {/* Axes */}
      {axes.map((_, i) => {
        const a = (Math.PI * 2 * i) / axes.length - Math.PI / 2;
        return (
          <line key={i} className="flexx-radar-axis" x1={cx} y1={cy} x2={cx + Math.cos(a) * r} y2={cy + Math.sin(a) * r} />
        );
      })}
      {/* Data shape */}
      <polygon className="flexx-radar-shape flexx-radar-draw" points={shape} />
      {/* Labels */}
      {axes.map((ax, i) => {
        const a = (Math.PI * 2 * i) / axes.length - Math.PI / 2;
        const lx = cx + Math.cos(a) * (r + 18);
        const ly = cy + Math.sin(a) * (r + 18);
        const v = Math.round(scores?.[ax.key] || 0);
        return (
          <g key={ax.key}>
            <text className="flexx-radar-label" x={lx} y={ly} textAnchor="middle" dominantBaseline="middle">
              {ax.label}
            </text>
            <text className="flexx-radar-value" x={lx} y={ly + 13} textAnchor="middle" dominantBaseline="middle">
              {v}%
            </text>
          </g>
        );
      })}
    </svg>
  );
}
